import {
  EcommerceTaxRatesAction,
  LOAD_ECOMMERCE_TAX_RATES,
  LOAD_ECOMMERCE_TAX_RATES_FAIL,
  LOAD_ECOMMERCE_TAX_RATES_SUCCESS,
  LoadEcommerceTaxRates,
  LoadEcommerceTaxRatesFail,
  LoadEcommerceTaxRatesSuccess,
} from "../actions";

export interface IEcommerceTaxRatesEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceTaxRatesState {
  entities: { [websiteId: number]: IEcommerceTaxRatesEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceTaxRatesState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceTaxRatesState = initialState, action: EcommerceTaxRatesAction): IEcommerceTaxRatesState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_TAX_RATES:
      payload = (<LoadEcommerceTaxRates>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_TAX_RATES_SUCCESS:
      payload = (<LoadEcommerceTaxRatesSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_TAX_RATES_FAIL:
      payload = (<LoadEcommerceTaxRatesFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
